import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rhombus",
  "use": "icon-rhombus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rhombus\"><defs><style></style></defs><path d=\"M512 69.479l442.498 442.498L512 954.475 69.502 511.977 512 69.479z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol